import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../../../services/authentication.service';
import { HeaderTemplateData } from '../../dialog/dialog-data.interface';

@Component({
    selector: 'payment-dialog',
    templateUrl: 'payment-dialog.html',
    styleUrls: ['payment-dialog.scss']
})
export class PaymentDialog implements OnInit {
    form: FormGroup;

    currencySymbol: string;
    header: HeaderTemplateData;
    constructor(
        public dialogRef: MatDialogRef<PaymentDialog>,
        @Inject(MAT_DIALOG_DATA) private data: HeaderTemplateData,
        private _snackBar: MatSnackBar,
        private _fb: FormBuilder,
        private _authService: AuthenticationService

    ) {
        if (data) {
            this.header = data;
        }
    }

    ngOnInit() {
        this.form = this._fb.group({
            amount: ['', Validators.required]
        });
        this.currencySymbol = this._authService.userInfo.account.settings.currencySymbol;
    }

    makePayment() {
        const value = this.form.controls['amount'].value;
        if (this.form.valid || value != 0) {
            this.dialogRef.close(value);
        } else {
            this._snackBar.open('Please enter a valid amount', 'Dismiss', {
                duration: 3500
            });
        }
    }
}
